import { CancelBtn } from 'components/Button/CancelBtn';
import CalendarInput from 'components/CalendarInput/CalendarInput';
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput';
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput';
import { Input } from 'components/Input/Input';
import { NavBar } from 'components/NavBar/NavBar';
import { useState } from 'react';
import { Box, Button, Flex, H1WithBack, PageFooter, PageWrapper, Separator, Tabs, TabsContainer } from 'styling/GlobalStyles';
import { TitleText } from 'styling/Typography';

export const AddOperationTrigger = () => {

    const [mode, setMode] = useState<'completion' | 'scheduled' | 'threshold'>('completion')
    const [state, setState] = useState()
    const handleChange = () => null
    const handleSelect = () => null

    const parseTasks = (data: any) => {
        return data ? data.data.map((item: any) => ({ label: item.name, value: item.id })) : []
    }
    const renderMode = () => {
        if (mode === 'completion') {
            return <CompletionSection handleSelect={handleSelect} parseTasks={parseTasks} />
        }
        if (mode === 'scheduled') {
            return <ScheduledSection />
        }
        return <ThresholdSection handleSelect={handleSelect} handleChange={handleChange} state={state} />
    }


    return <>
        <NavBar />
        <PageWrapper>
            <H1WithBack arrow title='Add Operation Trigger' />
            <Box style={{ marginTop: '1rem' }} >
                <Input labelText='Name' name='name' onChange={handleChange} placeholder='Enter name' />
                <TitleText style={{ marginTop: '1rem' }}>Mode</TitleText>
                <TabsContainer style={{ margin: '1rem 0' }}>
                    <Tabs active={mode === 'completion'} onClick={() => setMode('completion')}>Completion</Tabs>
                    <Tabs active={mode === 'scheduled'} onClick={() => setMode('scheduled')}>Scheduled</Tabs>
                    <Tabs active={mode === 'threshold'} onClick={() => setMode('threshold')}>Threshold</Tabs>
                </TabsContainer>
                {renderMode()}

                <Separator />
                <TitleText>Action</TitleText>
                <Flex gap='1rem' style={{ margin: '1rem 0' }}>
                    <HonestSelectInput name='type' options={actionOptions} onChange={handleSelect} labelText='Type' />
                    <HonestSelectInput name='type' options={priorityOptions} onChange={handleSelect} labelText='Priority' />
                </Flex>
                <HonestSelectAsyncInput
                    link='task/template/overviews'
                    labelText='Next Task Event'
                    onChange={handleSelect}
                    name='nextTaskTemplate'
                    placeholder='Search Task Templates'
                    parserFunction={parseTasks}
                />

            </Box>
        </PageWrapper>
        <PageFooter>
            <Flex gap='1rem' >
                <CancelBtn />
                <Button orange >Save</Button>
            </Flex>
        </PageFooter>
    </>
}

const actionOptions = [{ label: 'Create Task', value: 'createTask' }, { label: 'Create Workflow', value: 'createWorkflow' }, { label: 'Raise Issue', value: 'raiseIssue' }, { label: 'Notify Role', value: 'notifyRole' }]
const priorityOptions = [{ label: 'Normal', value: 'normal' }, { label: 'High', value: 'high' }, { label: 'Critical', value: 'critical' }]

const CompletionSection = ({ handleSelect, parseTasks }) => {
    return <HonestSelectAsyncInput
        link='task/template/overviews'
        labelText='Parent Task Template'
        onChange={handleSelect}
        name='parentTaskTemplate'
        placeholder='Search Task Templates'
        parserFunction={parseTasks}
    />
}

const ScheduledSection = () => {
    return <Flex gap='1rem' column >
        <Flex gap='1rem' >
            <Input labelText='Cron Expression' />
            <Input labelText='Time Zone' />
        </Flex>
        <Flex gap='1rem' >
            <CalendarInput width='100%' labelText='Active From' />
            <CalendarInput width='100%' labelText='Active Until' />
        </Flex>
    </Flex>
}

const ThresholdSection = ({ handleSelect, handleChange, state }) => {
    return <Flex gap='1rem' column>
        <Flex gap='1rem' alignEnd>
            <Input labelText='Threshold Value' width='100%' placeholder='Enter threshold value' />
            <HonestSelectInput name='op' options={thresholdOptions} onChange={handleSelect} width='200px' />
            <Input name='thresholdValue' onChange={handleChange} width='200px' placeholder='60...' />
        </Flex>
        <Flex gap='1rem' >
            <HonestSelectAsyncInput
                link='units'
                name='unit'
                labelText='Unit'
                placeholder='g, kg, ml...'
                defaultValue={state?.unit?.label}
                onChange={handleSelect}
                parserFunction={(data: any) => data.map((i: any) => ({ label: i.name, value: i.id }))}
            />
            <Input labelText='Cooldown minutes' placeholder='15...' />
        </Flex>
        <Flex gap='1rem' >
            <Input labelText='Debounce readings' placeholder='15...' />
            <Input labelText='Active hours (UTC, e.g. 06:00-18:00, optional)' placeholder='06:00-18:00' />
        </Flex>

    </Flex>
}

const thresholdOptions = [{ label: '>', value: 'greaterThan' }, { label: '<', value: 'lessThan' }, { label: '>=', value: 'greaterThanOrEqualTo' }, { label: '<=', value: 'lessThanOrEqualTo' }, { label: '=', value: 'equalTo' }]